import { useQuery } from '@tanstack/react-query';
import { GetThemePerformance, themeOverview } from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

const QUERY_KEY_GET_THEME_PERFORMANCE = 'QUERY_KEY_GET_THEME_PERFORMANCE';

export const useGetThemePerformance = ({ themeId }: { themeId: string }) =>
  useQuery({
    queryKey: [QUERY_KEY_GET_THEME_PERFORMANCE, themeId],
    queryFn: async ({ signal }) => {
      return await wretchRequest<GetThemePerformance>(
        themeOverview.getThemePerformance.path(themeId),
        {
          schema: themeOverview.getThemePerformance.schema,
          options: { signal },
        }
      );
    },
  });
